// extracted by mini-css-extract-plugin
export default {"amountBoxWrapper":"styles_amountBoxWrapper__3+5fd","innerWrapper":"styles_innerWrapper__kHNju","firstPara":"styles_firstPara__GKLwM","circle":"styles_circle__U0ZLW"};